import axios from 'axios';
import { haLaVoce } from '../utils/permessi';

/**
 * I MESSAGGI DELLA PIATTAFORMA AL CLIENTE: avvisi e promozioni mandati dal
 * backoffice (Sito › Messaggistica), che notification-service tiene e il
 * gateway espone sotto /api/messaggi (lvc-docs/it/messaggistica.md).
 *
 *   GET  /api/messaggi/miei                 -> [{id, titolo, testo, tipo, importante, il, letto}]
 *   GET  /api/messaggi/miei/non-letti       -> {nonLetti, importante: {id, titolo, testo} | null}
 *   POST /api/messaggi/miei/{id}/letto
 *   POST /api/messaggi/miei/letti           tutti letti
 *   GET  /api/messaggi/miei/preferenze      -> {promozioniEmail, promozioniTelegram}
 *   PUT  /api/messaggi/miei/preferenze      {promozioniEmail, promozioniTelegram}
 *
 * Chi li riceve lo decide il servizio quando il messaggio parte: qui si
 * leggono solo i propri. Le preferenze toccano solo le PROMOZIONI fuori dal
 * sito (email e Telegram): gli avvisi arrivano sempre, e nel sito si vede
 * tutto.
 */

function base() {
  const env = typeof window !== 'undefined' && window.env ? window.env : {};
  return (env.REACT_APP_API_URL || 'http://localhost:9001') + '/api/messaggi/miei';
}

function intestazioni() {
  const h = { 'Content-Type': 'application/json', 'X-Client-Surface': 'FRONTEND' };
  const token = window.localStorage.getItem('access_token');
  if (token) h.Authorization = `Bearer ${token}`;
  const tenant = window.env && window.env.REACT_APP_API_TENANT;
  if (tenant) h.TENANT_ID = tenant;
  return h;
}

export async function mieiMessaggi() {
  const r = await axios.get(base(), { headers: intestazioni() });
  return Array.isArray(r.data) ? r.data : [];
}

export async function nonLetti() {
  const r = await axios.get(`${base()}/non-letti`, { headers: intestazioni() });
  return r.data || { nonLetti: 0, importante: null };
}

export async function segnaLetto(id) {
  await axios.post(`${base()}/${encodeURIComponent(id)}/letto`, null, { headers: intestazioni() });
  messaggiCambiati();
}

export async function segnaTuttiLetti() {
  const r = await axios.post(`${base()}/letti`, null, { headers: intestazioni() });
  messaggiCambiati();
  return r.data;
}

export async function preferenze() {
  const r = await axios.get(`${base()}/preferenze`, { headers: intestazioni() });
  return r.data || {};
}

export async function salvaPreferenze({ promozioniEmail, promozioniTelegram }) {
  const r = await axios.put(`${base()}/preferenze`, { promozioniEmail, promozioniTelegram },
      { headers: intestazioni() });
  return r.data;
}

/* ---------- IL CONTO DEI NON LETTI, uno solo per tutta la pagina ----------

   Lo leggono la finestra degli importanti e la busta in testata. Invece di
   chiederlo due volte al minuto, lo chiede uno solo: chi ascolta si
   iscrive, e l'orologio gira finche' c'e' almeno qualcuno in ascolto.
   Si rilegge subito quando un messaggio diventa letto (qui o in un'altra
   pagina) e quando cambia il gettone (entrata, uscita). */

export const OGNI = 60 * 1000;
const EVENTO = 'messaggi:changed';

/** Chi legge o segna qualcosa avvisa, e il conto si rilegge da solo. */
export function messaggiCambiati() {
  window.dispatchEvent(new CustomEvent(EVENTO));
}

const ascoltatori = new Set();
let ultimo = { nonLetti: 0, importante: null };
let orologio = null;

async function rileggi() {
  if (!haLaVoce('SITE_MESSAGES_VIEW')) {
    ultimo = { nonLetti: 0, importante: null };
  } else {
    try {
      ultimo = await nonLetti();
    } catch (e) {
      return; // un giro saltato non cambia niente: si riprova al prossimo
    }
  }
  ascoltatori.forEach((cb) => cb(ultimo));
}

function quandoCambiaIlGettone(e) {
  if (!e || e.key === 'access_token' || e.key === null) rileggi();
}

/** Si iscrive al conto dei non letti; restituisce la funzione per staccarsi. */
export function ascoltaNonLetti(cb) {
  ascoltatori.add(cb);
  cb(ultimo);
  if (ascoltatori.size === 1) {
    rileggi();
    orologio = setInterval(rileggi, OGNI);
    window.addEventListener(EVENTO, rileggi);
    window.addEventListener('storage', quandoCambiaIlGettone);
  } else {
    rileggi();
  }
  return () => {
    ascoltatori.delete(cb);
    if (ascoltatori.size === 0) {
      clearInterval(orologio);
      orologio = null;
      window.removeEventListener(EVENTO, rileggi);
      window.removeEventListener('storage', quandoCambiaIlGettone);
    }
  };
}
